import HTTP from "@/_helpers/http";
import { TRANSACTIONS__API } from "@/_helpers/urls";
import { TRANSACTIONS__MUTATIONS } from "../mutation-types";
import { TRANSACTIONS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  creditout: [],
  totalCount: 0,
  isLoading: false,
  totalAmount: 0,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRANSACTIONS__MUTATIONS.TRXCREDITOUT](state, data) {
    state.creditout = data?.data?.summaries;
    state.totalCount = data?.data?.summaries?.length;
    state.totalAmount = data?.data?.totalAmount;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [TRANSACTIONS__ACTIONS.TRXCREDITOUT]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        trading_account_type_id,
        duration,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXCREDITOUT}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(TRANSACTIONS__MUTATIONS.TRXCREDITOUT, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().patch(
        TRANSACTIONS__API.UPDATEDEPOSIT,
        parameter
      );
      await dispatch(TRANSACTIONS__ACTIONS.TRXDEPOSITS);
      await dispatch(TRANSACTIONS__ACTIONS.TRXDASHBOARDDEPOSITS);
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
